import React from 'react';
import classnames from 'classnames';

import UserHeaderLoggedInDropdown from 'dpl/components/Header/UserHeaderLoggedInDropdown';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

import StripeChargeLoginButton from '../StripeChargeLoginButton';

export default function StripeChargeUserHeaderMenu() {
  const currentUser = useCurrentUser();
  const notificationCounts = useNotificationCounts();

  const handleSuccessfulLogin = async () => {
    await currentUser.fetch();
    window.location.reload();
  };

  if (currentUser.isLoggedIn) {
    return (
      <div
        className={classnames('pv2 ph2', {
          'ba b--light-gray br3': !(
            isFeatureEnabled(FEATURES.REL_PAYMENT_REQUEST_STEPS_V2) ||
            isFeatureEnabled(FEATURES.REL_PAYMENT_REQUEST_SUCCESS_V2)
          )
        })}
      >
        <UserHeaderLoggedInDropdown
          currentUser={currentUser}
          totalNotificationsCount={notificationCounts.totalNotificationsCount}
          handleLogout={async () => {
            await currentUser.logout();
            window.location.reload();
          }}
        />
      </div>
    );
  }

  return <StripeChargeLoginButton onSuccessfulLogin={handleSuccessfulLogin} />;
}
